/* Se carga desde varias secciones a la vez, asi que se ejecuta una sola vez. */
(function () {
  if (window.__resenasCargado) return;
  window.__resenasCargado = true;

/* Reseñas nativas. Sustituye a Loox.

   Los datos viven en assets/resenas.json y las fotos en assets/.
   Cada elemento <resenas-bloque> recibe por data-* la URL del JSON, la de la
   carpeta de assets y el handle del producto (vacio en la portada). */

const cacheDatos = {};

function pedirDatos(url) {
  if (!cacheDatos[url]) {
    cacheDatos[url] = fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .catch(() => null);
  }
  return cacheDatos[url];
}

function escapa(t) {
  const d = document.createElement('div');
  d.textContent = t == null ? '' : String(t);
  return d.innerHTML;
}

let contadorEstrellas = 0;

function estrellas(nota, clase) {
  const llenas = Math.floor(nota);
  const media = nota - llenas >= 0.25 && nota - llenas < 0.75;
  const casi = nota - llenas >= 0.75;
  contadorEstrellas += 1;
  const grupo = contadorEstrellas;
  let html = `<span class="res-estrellas ${clase || ''}" role="img" aria-label="${nota} de 5 estrellas">`;
  for (let i = 1; i <= 5; i += 1) {
    let relleno = 0;
    if (i <= llenas || (i === llenas + 1 && casi)) relleno = 1;
    else if (i === llenas + 1 && media) relleno = 0.5;
    const id = `resg${grupo}-${i}`;
    html += `<svg viewBox="0 0 20 20" aria-hidden="true">
      ${relleno === 0.5 ? `<defs><linearGradient id="${id}"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs>` : ''}
      <path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"
        fill="${relleno === 1 ? 'currentColor' : relleno === 0.5 ? `url(#${id})` : 'none'}"
        stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    </svg>`;
  }
  return `${html}</span>`;
}

/* Baraja estable: mismo orden en cada recarga para un mismo producto,
   pero distinto entre productos. */
function baraja(lista, semilla) {
  let s = 0;
  for (let i = 0; i < semilla.length; i += 1) s = (s * 31 + semilla.charCodeAt(i)) >>> 0;
  const a = lista.slice();
  for (let i = a.length - 1; i > 0; i -= 1) {
    s = (s * 1664525 + 1013904223) >>> 0;
    const j = s % (i + 1);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/* Numero de columnas del muro segun el ancho de pantalla. */
function columnasSegunPantalla() {
  const w = window.innerWidth;
  if (w >= 990) return 4;
  if (w >= 750) return 3;
  return 2;
}

class ResenasBloque extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.handle || '';
    this.base = this.dataset.assets || '';
    this.porPagina = parseInt(this.dataset.porPagina, 10) || 6;
    this.filtro = 0;
    this.mostradas = 0;
    this.lista = [];
  }

  connectedCallback() {
    pedirDatos(this.dataset.json).then((datos) => {
      if (!datos) return this.vacio('No se pudieron cargar las reseñas.');
      this.datos = datos;
      this.lista = this.ordena(datos);
      if (!this.lista.length) return this.vacio();
      this.pinta();
    });
  }

  /* Orden:
     - En la portada: todas, de la mas reciente a la mas antigua.
     - En una ficha con reseñas propias: primero las suyas, despues el resto
       barajado (con semilla fija para que no cambie en cada recarga).
     - En una ficha sin reseñas propias: todas por fecha, mas recientes primero.
     En los tres casos las de 1 y 2 estrellas se van al final. */
  ordena(datos) {
    const porFecha = (a, b) => (a.f < b.f ? 1 : a.f > b.f ? -1 : 0);
    const malas = (r) => r.p <= 2;

    const propias = this.handle ? (datos.resenas[this.handle] || []).slice() : [];
    let resto;

    if (!this.handle) {
      resto = Object.values(datos.resenas).flat().sort(porFecha);
    } else if (propias.length) {
      resto = Object.entries(datos.resenas)
        .filter(([h]) => h !== this.handle)
        .flatMap(([, v]) => v);
      resto = baraja(resto, this.handle);
    } else {
      resto = Object.values(datos.resenas).flat().sort(porFecha);
    }

    const orden = this.handle && propias.length ? propias.sort(porFecha).concat(resto) : resto;

    /* Primero las que llevan foto, despues las de solo texto, y las malas
       al final de todo. Dentro de cada grupo se respeta el orden anterior. */
    const conFoto = (r) => r.img && r.img.length > 0;
    const buenas = orden.filter((r) => !malas(r));
    const flojas = orden.filter(malas);
    return [
      ...buenas.filter(conFoto),
      ...buenas.filter((r) => !conFoto(r)),
      ...flojas.filter(conFoto),
      ...flojas.filter((r) => !conFoto(r)),
    ];
  }

  vacio(mensaje) {
    this.innerHTML = `<p class="res__vacio">${escapa(mensaje || 'Este producto todavía no tiene reseñas.')}</p>`;
    this.dispatchEvent(new CustomEvent('resenas:vacio', { bubbles: true }));
  }

  /* La nota y el reparto son siempre los de toda la tienda, no los del
     producto que se esta viendo. */
  get resumen() {
    const todas = Object.values(this.datos.resenas).flat();
    const n = todas.length;
    const m = todas.reduce((a, r) => a + r.p, 0) / n;
    const reparto = [0, 0, 0, 0, 0];
    todas.forEach((r) => {
      reparto[r.p - 1] += 1;
    });
    return { n, m: Math.round(m * 100) / 100, reparto };
  }

  pinta() {
    const { n, m, reparto } = this.resumen;
    const barras = [5, 4, 3, 2, 1]
      .map((estrella) => {
        const cuenta = reparto[estrella - 1];
        const pct = n ? Math.round((cuenta / n) * 100) : 0;
        return `<div class="res__barra">
            <span>${estrella} \u2605</span>
            <span class="res__barra-pista"><span class="res__barra-relleno" style="width:${pct}%"></span></span>
            <span class="res__barra-num">${cuenta}</span>
          </div>`;
      })
      .join('');

    this.innerHTML = `
      <div class="res__cabecera">
        <div class="res__nota">
          <div class="res__nota-numero">${m.toFixed(2).replace('.', ',')}</div>
          ${estrellas(m, 'res-estrellas--lg res-estrellas--amarillas')}
          <div class="res__nota-total">${n} ${n === 1 ? 'rese\u00f1a' : 'rese\u00f1as'}</div>
        </div>
        <div class="res__barras">${barras}</div>
      </div>
      <div class="res__muro" data-muro></div>
      <button class="button button--secondary res__mas" type="button" data-mas hidden>Ver m\u00e1s rese\u00f1as</button>
    `;

    this.muro = this.querySelector('[data-muro]');
    this.boton = this.querySelector('[data-mas]');
    this.mostradas = 0;
    this.tarjetas = [];
    this.creaColumnas(columnasSegunPantalla());
    this.pintaPagina();

    this.boton.addEventListener('click', () => this.pintaPagina());

    /* Solo se rehace el reparto si cambia el numero de columnas. */
    this.columnasActuales = columnasSegunPantalla();
    let temporizador;
    window.addEventListener('resize', () => {
      clearTimeout(temporizador);
      temporizador = setTimeout(() => {
        const cols = columnasSegunPantalla();
        if (cols !== this.columnasActuales) {
          this.columnasActuales = cols;
          this.creaColumnas(cols);
          this.tarjetas.forEach((t) => this.masCorta().appendChild(t));
        }
      }, 200);
    });
  }

  creaColumnas(n) {
    this.muro.innerHTML = '';
    this.columnas = [];
    for (let i = 0; i < n; i += 1) {
      const col = document.createElement('div');
      col.className = 'res__col';
      this.muro.appendChild(col);
      this.columnas.push(col);
    }
  }

  masCorta() {
    return this.columnas.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a));
  }

  get filtradas() {
    return this.lista;
  }

  todasLasFotos() {
    return this.filtradas.flatMap((r) => r.img);
  }

  pintaPagina() {
    const lote = this.filtradas.slice(this.mostradas, this.mostradas + this.porPagina);
    lote.forEach((r) => {
      const envoltorio = document.createElement('div');
      envoltorio.innerHTML = this.item(r);
      const tarjeta = envoltorio.firstElementChild;
      this.tarjetas.push(tarjeta);
      this.masCorta().appendChild(tarjeta);
    });
    this.mostradas += lote.length;
    this.boton.hidden = this.mostradas >= this.filtradas.length;
  }

  item(r) {
    const foto = r.img.length
      ? `<img class="res__item-foto" src="${this.base}${escapa(r.img[0])}" alt="Foto de la rese\u00f1a de ${escapa(r.n)}" loading="lazy" width="600" height="600">`
      : '';
    const extras =
      r.img.length > 1
        ? `<div class="res__fotos">${r.img
            .slice(1)
            .map(
              (f) =>
                `<img class="res__foto" src="${this.base}${escapa(f)}" alt="Foto de la rese\u00f1a de ${escapa(r.n)}" loading="lazy" width="150" height="150">`
            )
            .join('')}</div>`
        : '';
    /* La etiqueta solo se pone en las que constan como compra verificada. */
    const verificada = r.v ? '<span class="res__verificada">Compra verificada</span>' : '';
    return `<article class="res__item">
      ${foto}
      <div class="res__item-cuerpo">
        ${estrellas(r.p, 'res-estrellas--sm res-estrellas--amarillas')}
        <p class="res__autor">${escapa(r.n)}${verificada}</p>
        <p class="res__texto">${escapa(r.t)}</p>
        ${r.var ? `<p class="res__variante">Talla: ${escapa(r.var)}</p>` : ''}
        ${extras}
      </div>
    </article>`;
  }
}

/* Estrellas sueltas: bajo el titulo del producto, en tarjetas, etc. */

class ResenasEstrellas extends HTMLElement {
  connectedCallback() {
    pedirDatos(this.dataset.json).then((datos) => {
      if (!datos) return;
      /* Siempre la nota global, tenga o no reseñas propias este producto. */
      const nota = datos.global.m;
      const destino = this.dataset.destino || '#resenas';
      const texto = this.dataset.texto || '+10.000 clientes satisfechos';
      this.innerHTML = `<span class="res-resumen-linea res-resumen-linea--destacada">
          ${estrellas(nota, 'res-estrellas--xl res-estrellas--amarillas')}
          <a class="res-resumen-linea__texto" href="${escapa(destino)}">${escapa(texto)}</a>
        </span>`;
    });
  }
}

if (!customElements.get('resenas-bloque')) customElements.define('resenas-bloque', ResenasBloque);
if (!customElements.get('resenas-estrellas')) customElements.define('resenas-estrellas', ResenasEstrellas);
})();
